<template>
  <el-dialog
    v-if="dialogShow"
    v-model="dialogShow"
    :title="title"
    :close-on-click-modal="false"
    destroy-on-close
  >
    <data-form
      ref="data-form"
      :show-confirm="false"
      :fields="fields"
      :labelWidth="labelWidth"
      @submit="submit"
      @addImg="addImg"
      @delImg="delImg"
      @changeName="changeName"
    />

    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="dialogShow = false">取 消</el-button>
      <el-button
        v-if="confirm"
        type="primary"
        @click="handleSubmit"
      >{{ confirmText }}</el-button>
    </div>
  </el-dialog>
</template>
<script>

export default {
  props: {
    title: {
      type: String,
      default: '表单弹窗'
    },
    confirm: {
      type: Boolean,
      default: true
    },
    confirmText: {
      type: String,
      default: '确 定'
    },
    autoClose: {
      type: Boolean,
      default: true
    },
    labelWidth: {
      type: Number,
      default: 100
    },
    fields: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data: () => {
    return {
      dialogShow: false,
    }
  },
  methods: {
    handleSubmit () {
      this.$refs['data-form'].submit()
    },
    submit (data) {
      this.$emit('submit', data)
      if (this.autoClose) {
        this.dialogShow = false
      }
    },
    addImg (e) {
      this.$emit('addImg', e)
    },
    delImg (e) {
      this.$emit('delImg', e)
    },
    changeName (e) {
      this.$emit('changeName', e)
    },
    show (data) {
      this.dialogShow = true
      this.$nextTick(() => {
        this.$refs['data-form'].show(data)
      })
    },
    close() {
      this.dialogShow = false
    }
  }
}
</script>

<style scoped>
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader :hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
